import { FC, PropsWithChildren } from 'react'

import { View } from '@react-pdf/renderer'

const Row: FC<PropsWithChildren> = ({ children }) => (
  <View style={{ flexDirection: 'row', height: 48 }}>{children}</View>
)

export default Row
